import AccountLayout from "../structure/AccountLayout";
import AccountNav from "../../../../logic/navigation/accountNav";
import AccountTertiaryNav from "../structure/AccountTertiaryNav";
import useOrders from "../../../../services/state/account/useOrders";
import useValueChangeListener from "../../../../services/state/general/useValueChangeListener";
import LoadingSwitcher from "../../../general/loading/LoadingSwitcher";
import HeaderOrder from "../../order/headers/HeaderOrder";
import {useState} from "react";
import Popup from "../../../../../components/general/popup/Popup";
import Dialog from "../../../general/dialog/Dialog";
import DialogTitle from "../../../general/dialog/DialogTitle";
import DialogMessage from "../../../general/dialog/DialogMessage";
import DialogButtonContainer from "../../../general/dialog/DialogButtonContainer";
import DialogButton, {DIALOG_BUTTON_TYPE} from "../../../general/dialog/DialogButton";
import GeneralMessageDialog from "../../../general/dialog/GeneralMessageDialog";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import useSession from "../../../../services/state/session/useSession";
import DialogLoading from "../../../general/dialog/DialogLoading";
import {useNavigate} from "react-router-dom";

const acctBreadcrumbTrail = [AccountNav.items.home, AccountNav.items.orders, {...AccountNav.items.openOrder, selected: true}];

const AmendingDialog = ({ order, onBack, afterFailure }) => {

    const navigate = useNavigate();

    const message = "Amending your order will replace your current cart with this order. " +
        "You must go through checkout to save your changes. " +
        "Credit card customers will be charged for any extras, or refunded for reductions. " +
        "If you don’t complete checkout before the delivery cutoff, you’ll lose your delivery date."

    const session = useSession();
    const amendOrder = useCheckoutStore(state => state.amendOrder);
    const reopening = useCheckoutStore(state => state.loading?.amend);
    const error = useCheckoutStore(state => state.error?.amend);

    useValueChangeListener(() => error && afterFailure(error), [error]);

    const onAmend = () => {
        amendOrder(session, order.id, () => navigate('/checkout'));
    }

    return (
        <>
            {!reopening &&
                <Popup>
                    <Dialog>
                        <DialogTitle>Amend Order {order.DocumentNo}</DialogTitle>
                        <DialogMessage>{message}</DialogMessage>
                        <DialogButtonContainer>
                            <DialogButton type={DIALOG_BUTTON_TYPE.neutral} onClick={onBack}>
                                Cancel
                            </DialogButton>
                            <DialogButton type={DIALOG_BUTTON_TYPE.positive} onClick={onAmend}>
                                Amend Order
                            </DialogButton>
                        </DialogButtonContainer>
                    </Dialog>
                </Popup>
            }
            <DialogLoading title="Re-Opening Order" loading={reopening} />
        </>
    )

}

const OpenOrderContent = () => {

    const {
        loading,
        getOrders,
        orders
    } = useOrders();

    const [ amending, setAmending ] = useState();
    const [ failed, setFailed ] = useState(false);

    useValueChangeListener(() => {
        getOrders({open:true, getShipment:true, pageSize:100});
    }, [], [false]);

    const onAmend = (order) => {
        setAmending(order);
    }

    const canAmend = (order) => {
        return !(order.m_inout?.length > 0);
    }

    return (
        <div className={"acct-content max-width-set"}>
            <LoadingSwitcher loading={loading}>
                {!orders || orders.length === 0 ?
                    <>
                        <p className="acct-h1">No orders</p>
                        <p className="acct-h4">You currently do not have any open orders</p>
                    </> :
                    <>
                        {orders.map(o => <HeaderOrder order={o} showAmend onAmend={onAmend} canAmend={canAmend(o)} />)}
                    </>
                }
                {amending &&
                    <AmendingDialog
                        order={amending}
                        onBack={() => setAmending(null)}
                        afterFailure={() => {setAmending(null); setFailed(true)}}
                    />
                }
                {failed &&
                    <GeneralMessageDialog
                        title="Something went wrong"
                        message="something has gone wrong, you are currently not able to make amendments to that order."
                        buttonText="OK"
                        onDismiss={() => setFailed(false)}
                    />
                }
            </LoadingSwitcher>
        </div>
    )


}

const OpenOrderLayout = () => {

    return (
        <AccountLayout breadcrumbTrail={acctBreadcrumbTrail}>
            <AccountTertiaryNav navList={acctBreadcrumbTrail[1].children} />
            <OpenOrderContent />
        </AccountLayout>
    )
}

export default OpenOrderLayout;
